/** Stripped down query for AI purpose */
import type { EntityType, SearchRequest } from '@tunasong/schemas'
import type { QueryProps } from './query-props.js'

const sortClause = {
  updated: [{ updatedAt: { order: 'desc' } }, { createdAt: 'desc' }, '_score'],
}

const typeQuery = ({
  query,
  types,
  size = 20,
  sort = 'updated',
}: QueryProps & { types?: EntityType[]; query?: string; sort?: 'updated' }): SearchRequest => ({
  index: 'entities',
  size,
  from: 0,
  /** embeddings are large - don't return them by default */
  _source_excludes: ['embedding', 'acls', 'userId'],
  body: {
    query: {
      bool: {
        must: query
          ? {
              simple_query_string: {
                query: `${query ?? ''}*`,
                fields: ['name', 'description'],
              },
            }
          : undefined,
        should: query
          ? {
              match_phrase: {
                name: {
                  query: `${query}`,
                  boost: 5,
                },
              },
            }
          : undefined,
        filter: {
          terms: {
            type: types ? types : [query],
          },
        },
      },
    },
    sort: sortClause[sort],
  },
})

export default typeQuery
